<template>
    <div>
        <vx-card class="mb-4">
            <div class="w-full flex flex-no-wrap">
                <div class="w-1/2">
                    <h5 class="mb-4">Update Information</h5>
                    <div class="table-row w-full mb-5">
                        <div class="table-cell w-2/5 p-4">
                            Company Legal Name
                            <span class="text-danger">*</span>
                        </div>
                        <div class="table-cell w-3/5 p-4">
                            <vs-input
                                    type="text"
                                    placeholder="Company Legal Name"
                                    v-model="merchantInfo.name"
                                    class="w-full mb-4 no-icon-border"
                                    name="Company legal name"
                                    v-validate="'required'"
                                    data-vv-validate-on="blur"
                            />
                            <span class="text-danger text-sm">{{ errors.first('Company legal name') }}</span>
                        </div>
                    </div>
                    <div class="table-row w-full">
                        <div class="table-cell w-2/5 p-4">
                            Brand Name
                            <span class="text-danger">*</span>
                        </div>
                        <div class="table-cell w-3/5 p-4">
                            <vs-input
                                    type="text"
                                    placeholder="Brand Name"
                                    v-model="merchantInfo.brandName"
                                    class="w-full mb-4 no-icon-border"
                                    name="Brand name"
                                    v-validate="'required'"
                                    data-vv-validate-on="blur"
                            />
                            <span class="text-danger text-sm">{{ errors.first('Brand name') }}</span>
                        </div>
                    </div>
                    <div class="table-row w-full">
                        <div class="table-cell w-2/5 p-4">
                            Email Address
                            <span class="text-danger">*</span>
                        </div>
                        <div class="table-cell w-3/5 p-4">
                            <vs-input
                                    type="text"
                                    placeholder="Emaill Address"
                                    v-model="merchantInfo.email"
                                    class="w-full mb-4 no-icon-border"
                                    name="Email address"
                                    v-validate="'required'"
                                    data-vv-validate-on="blur"
                            />
                            <span class="text-danger text-sm">{{ errors.first('Email address') }}</span>
                        </div>
                    </div>
                    <div class="table-row w-full">
                        <div class="table-cell w-2/5 p-4">
                            Address
                            <span class="text-danger">*</span>
                        </div>
                        <div class="table-cell w-3/5 p-4">
                            <vs-input
                                    type="text"
                                    placeholder="Address"
                                    v-model="merchantInfo.address"
                                    class="w-full mb-4 no-icon-border"
                                    name="Address"
                                    v-validate="'required'"
                                    data-vv-validate-on="blur"
                            />
                            <span class="text-danger text-sm">{{ errors.first('Address') }}</span>
                        </div>
                    </div>
                    <div class="table-row w-full">
                        <div class="table-cell w-w-2/5 p-4">Web Address</div>
                        <div class="table-cell w-3/5 p-4">
                            <vs-input
                                    type="text"
                                    placeholder="Web Address"
                                    v-model="merchantInfo.webAddress"
                                    class="w-full mb-4 no-icon-border"
                            />
                        </div>
                    </div>
                    <div class="table-row w-full">
                        <div class="table-cell w-2/5 p-4">
                            Director's Name
                            <span class="text-danger">*</span>
                        </div>
                        <div class="table-cell w-3/5 p-4">
                            <vs-input
                                    type="text"
                                    placeholder="Director's Name"
                                    v-model="merchantInfo.directorName"
                                    class="w-full mb-4 no-icon-border"
                                    name="Director name"
                                    v-validate="'required'"
                                    data-vv-validate-on="blur"
                            />
                            <span class="text-danger text-sm">{{ errors.first('Director name') }}</span>
                        </div>
                    </div>
                    <div class="table-row w-full">
                        <div class="table-cell w-2/5 p-4">
                            Director's Identity
                            <span class="text-danger">*</span>
                        </div>
                        <div class="table-cell w-3/5 p-4">
                            <div class="flex flex-no-wrap">
                                <vs-select
                                        placeholder="Type"
                                        v-model="merchantInfo.directorIdentityType"
                                        class="w-3/5 mb-4 no-icon-border"
                                        name="identity-type"
                                        v-validate="'required'"
                                        data-vv-validate-on="blur"
                                >
                                    <vs-select-item
                                            :key="index"
                                            :value="item.id"
                                            :text="item.name"
                                            v-for="(item,index) in identityTypes"
                                    />
                                </vs-select>
                                <vs-input
                                        v-if="merchantInfo.directorIdentityType === 1"
                                        type="text"
                                        placeholder="Identity Number"
                                        v-model="merchantInfo.directorIdentityNumber"
                                        class="w-full ml-1 mb-4 no-icon-border"
                                        name="identity number"
                                        v-validate="'required|numeric|length:16'"
                                        data-vv-validate-on="blur"/>
                                <vs-input
                                        v-if="merchantInfo.directorIdentityType !== 1"
                                        type="text"
                                        placeholder="Identity Number"
                                        v-model="merchantInfo.directorIdentityNumber"
                                        class="w-full ml-1 mb-4 no-icon-border"
                                        name="identity number"
                                        v-validate="'required'"
                                        data-vv-validate-on="blur"/>
                            </div>
                            <div class="w-full flex flex-no-wrap">
                                <div class="w-2/5 mb-4"></div>
                                <div class="w-full mb-4">
                  <span
                          class="text-danger text-sm"
                  >{{ errors.first('identity-type')||errors.first('identity number') }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
                    <img class="w-1/2 mx-auto" src="@/assets/images/pages/graphic-4.png" alt="login"/>
                </div>
            </div>
            <div class="w-full">
                <div class="w-1/2">
                    <div class="flex flex-wrap w-full mb-5">
                        <div class="w-2/5 p-4">Legality Documents</div>
                        <div class="w-3/5 flex flex-wrap">
                            <div class="w-full flex flex-no-wrap">
                                <custom-upload
                                        title="Company Deed"
                                        :file-name="documents[0].file_name"
                                        :on-change-callback="handleFileUpload"
                                        :on-delete-callback="handleDelete"/>
                                <div class="self-center m-right-download" v-if="documents[0].url">
                                    <vx-tooltip text="Download" position="top">
                                        <vs-button class="mb-4 md:mb-0" icon-pack="feather"
                                                   icon="icon-download" :target="true"
                                                   :href="downloadUrl+documents[0].url"></vs-button>
                                    </vx-tooltip>
                                </div>
                            </div>
                            <div class="w-full flex flex-no-wrap">
                                <custom-upload
                                        title="Business Registration"
                                        :file-name="documents[1].file_name"
                                        :on-change-callback="handleFileUpload"
                                        :on-delete-callback="handleDelete"/>
                                <div class="self-center m-right-download" v-if="documents[1].url">
                                    <vx-tooltip text="Download" position="top">
                                        <vs-button class="mb-4 md:mb-0" icon-pack="feather"
                                                   icon="icon-download" :target="true"
                                                   :href="downloadUrl+documents[1].url"></vs-button>
                                    </vx-tooltip>
                                </div>
                            </div>
                            <div class="w-full flex flex-no-wrap">
                                <custom-upload
                                        title="Company Registration"
                                        :file-name="documents[2].file_name"
                                        :on-change-callback="handleFileUpload"
                                        :on-delete-callback="handleDelete"/>
                                <div class="self-center m-right-download" v-if="documents[2].url">
                                    <vx-tooltip text="Download" position="top">
                                        <vs-button class="mb-4 md:mb-0" icon-pack="feather"
                                                   icon="icon-download" :target="true"
                                                   :href="downloadUrl+documents[2].url"></vs-button>
                                    </vx-tooltip>
                                </div>
                            </div>
                            <div class="w-full flex flex-no-wrap">
                                <custom-upload
                                        title="Director’s Identity Document"
                                        :file-name="documents[3].file_name"
                                        :on-change-callback="handleFileUpload"
                                        :on-delete-callback="handleDelete"/>
                                <div class="self-center m-right-download" v-if="documents[3].url">
                                    <vx-tooltip text="Download" position="top">
                                        <vs-button class="mb-4 md:mb-0" icon-pack="feather"
                                                   icon="icon-download" :target="true"
                                                   :href="downloadUrl+documents[3].url"></vs-button>
                                    </vx-tooltip>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="w-1/2 text-right">
                <span class="text-danger">* required field</span>
            </div>
        </vx-card>
        <vx-card>
            <div class="w-full text-right">
                <vs-button type="border" @click="backPage">Cancel</vs-button>
                <vs-button class="ml-4" @click="submitRequest">Submit</vs-button>
            </div>
        </vx-card>
    </div>
</template>

<script>
    import {url} from '@/configs/apiUrl'
    import CustomUpload from "@/components/upload/custom-upload";
    import MerchantAPI from "@/network/api/MerchantAPI";
    import AuthAPI from "@/network/api/AuthAPI";
    import FileAPI from "@/network/api/FileAPI";

    export default {
        components: {CustomUpload},
        data() {
            return {
                downloadUrl: url.content_delivery_url,
                merchantInfo: {
                    id: '',
                    name: "",
                    brandName: "",
                    email: "",
                    address: "",
                    webAddress: "",
                    directorName: "",
                    directorIdentityType: "",
                    directorIdentityNumber: ""
                },
                merchantCredential: {
                    midAino: ''
                },
                identityTypes: [
                    {
                        id: 1,
                        name: "KTP"
                    },
                    {
                        id: 2,
                        name: "Passport"
                    }
                ],
                documents: [
                    {
                        name: "Company Deed",
                        file_name: "",
                        url: ""
                    },
                    {
                        name: "Business Registration",
                        file_name: "",
                        url: ""
                    },
                    {
                        name: "Company Registration",
                        file_name: "",
                        url: ""
                    },
                    {
                        name: "Director’s Identity Document",
                        file_name: "",
                        url: ""
                    }
                ]
            }
        },
        mounted() {
            AuthAPI.UserInfo().then((result) => {
                if (result.data !== null) {
                    for (let merchant of result.data.merchant) {
                        this.merchantInfo.id = merchant.id
                        this.merchantInfo.name = merchant.full_name
                        this.merchantInfo.brandName = merchant.brand_name
                        this.merchantInfo.email = merchant.email
                        this.merchantInfo.webAddress = merchant.url
                        if (merchant.details !== null) {
                            if (merchant.details.address !== undefined)
                                this.merchantInfo.address = merchant.details.address
                            if (merchant.details.director_name !== undefined)
                                this.merchantInfo.directorName = merchant.details.director_name
                            if (merchant.details.director_identity_type !== undefined)
                                this.merchantInfo.directorIdentityType = merchant.details.director_identity_type
                            if (merchant.details.director_identity_number !== undefined)
                                this.merchantInfo.directorIdentityNumber = merchant.details.director_identity_number
                            if (merchant.details.documents !== undefined)
                                this.documents = merchant.details.documents
                        }
                    }
                }
            })
        },
        computed: {
            validateForm() {
                return (
                    !this.errors.any() &&
                    this.merchantInfo.name != "" &&
                    this.merchantInfo.brandName != "" &&
                    this.merchantInfo.email != "" &&
                    this.merchantInfo.address != "" &&
                    this.merchantInfo.directorName != "" &&
                    this.merchantInfo.directorIdentityType != "" &&
                    this.merchantInfo.directorIdentityNumber != ""
                );
            },
            validateFormDirIdentity() {
              let result = true
              if (parseInt(this.merchantInfo.directorIdentityType)===1) {
                let identityNumber = String(this.merchantInfo.directorIdentityNumber)
                if (identityNumber.length!=16 || isNaN(identityNumber)===true) {
                  result = false
                }
              }
              return result
            },
        },
        methods: {
            handleFileUpload(file, title) {
                let payload = {
                    file: file
                }

                FileAPI.Upload(payload).then((result) => {
                    if (title === this.documents[0].name) {
                        this.documents[0].file_name = file.name
                        this.documents[0].url = result.data.url
                    } else if (title === this.documents[1].name) {
                        this.documents[1].file_name = file.name
                        this.documents[1].url = result.data.url
                    } else if (title === this.documents[2].name) {
                        this.documents[2].file_name = file.name
                        this.documents[2].url = result.data.url
                    } else if (title === this.documents[3].name) {
                        this.documents[3].file_name = file.name
                        this.documents[3].url = result.data.url
                    }
                })
            },
            handleDelete(file, title) {
                if (title === this.documents[0].name) {
                    this.documents[0].file_name = ""
                    this.documents[0].url = ""
                } else if (title === this.documents[1].name) {
                    this.documents[1].file_name = ""
                    this.documents[1].url = ""
                } else if (title === this.documents[2].name) {
                    this.documents[2].file_name = ""
                    this.documents[2].url = ""
                } else if (title === this.documents[3].name) {
                    this.documents[3].file_name = ""
                    this.documents[3].url = ""
                }
            },
            backPage() {
                this.$router.push({name: 'accountInfo'});
            },
            submitRequest() {
                if (!this.validateForm) {
                  this.$vs.notify({
                    title: "Warning",
                    text: "Please input all required fields!",
                    iconPack: "feather",
                    icon: "icon-alert-circle",
                    color: "warning",
                    position: "top-right"
                  })
                  return false;
                }

                if (!this.validateFormDirIdentity) {
                  this.$vs.notify({
                    title: "Warning",
                    text: "Director's identity must number with 16 character!",
                    iconPack: "feather",
                    icon: "icon-alert-circle",
                    color: "warning",
                    position: "top-right"
                  })
                  return false;
                }

                let payload = {
                    id: this.merchantInfo.id,
                    merchantInfo: {
                        full_name: this.merchantInfo.name,
                        brand_name: this.merchantInfo.brandName,
                        email: this.merchantInfo.email,
                        url: this.merchantInfo.webAddress,
                        details: {
                            address: this.merchantInfo.address,
                            director_name: this.merchantInfo.directorName,
                            director_identity_number: this.merchantInfo.directorIdentityNumber,
                            director_identity_type: this.merchantInfo.directorIdentityType,
                            documents: this.documents
                        },
                        user_action: JSON.parse(localStorage.getItem('userInfo')).displayName
                    }
                }

                MerchantAPI.UpdateAccountInfo(payload).then(() => {
                    this.$vs.notify({
                        title: "Info",
                        text: "Account updated!",
                        iconPack: "feather",
                        icon: "icon-check-square",
                        color: "success",
                        position: "top-right"
                    });

                    this.$router.push({name: 'accountInfo'});
                }).catch((err) => {
                    this.$vs.notify({
                        title: "Info",
                        text: err.response.data.message,
                        iconPack: "feather",
                        icon: "icon-alert-circle",
                        color: "danger",
                        position: "top-right"
                    });
                })
            }
        }
    };
</script>

<style lang="scss">
    .con-input-upload {
        display: flex;
        flex-wrap: wrap;
        width: 100%;
        height: 73px;
        text-align: left;
        margin: 0px;
        flex-direction: column;

        .text-input {
            text-align: left;
            width: 80%;
            display: block;
        }

        .vs-upload--button-upload {
            text-align: right;
            width: 20%;
            display: block;
            right: 0;
            bottom: auto;
            margin-right: 10px;
        }
    }

    .m-right-download {
        margin-right: -39px;
    }
</style>



